import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, message, Spin } from 'antd'
import { Redirect } from 'react-router-dom'
import '../../css/patient.scss'
import util from '../../util/util'
import { Patient as PatientComponents } from '../../component'
import { getHelp, pages } from '../../tutorials'

var { Table, ActionBar, Filter } = PatientComponents

const Patient = (props) => {
  useEffect(() => {
    getHelp(pages.PATIENTLIST)
  }, [])
  return props.token == undefined ? (
    <Redirect to='/login' />
  ) : (
    <>
      <Spin spinning={props.isLoading}>
        <Row type='flex' className='patientRow'>
          <Col span={24} flex='auto'>
            <Filter />
            <ActionBar />
            <Table />
          </Col>
        </Row>
        {props.successMessage ? message.success(props.successMessage) : null}
      </Spin>
    </>
  )
}

Patient.propTypes = {
  hasError: PropTypes.bool,
  isLoading: PropTypes.bool,
  message: PropTypes.string,
  token: PropTypes.string,
  customer: PropTypes.object,
  successMessage: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    hasError: state.patient.hasError,
    message: state.patient.message,
    isLoading: state.profile.isLoading,
    customer: state.profile.customer,
    successMessage: state.profile.successMessage,
  }
}

export default connect(mapStateToProps, null)(Patient)
